import { Entity } from "app/models/entity";
import { IPagination } from "../_apiResponse";
import {Client, emptyClient, sqlTable} from "../clients/_models";
import {Ride} from "../rides/_models";

export interface ServicesPaginated extends IPagination<Service> { }
export interface Service extends Entity {
    title: string
    client: Client
    client_referent: string
    client_referent_phone: string
    start_date: string // @TODO: controllare le date
    end_date: string // @TODO: controllare le date
    notes: string
    quotation: string
    quotation_date: string // @TODO: controllare le date
    purchase_price: number | null
    selling_price: number | null
    invoice: string
    status: string
    rides: Ride[]
}

export const emptyService = {
    id: 0,
    title: '',
    client: emptyClient,
    client_referent: '',
    client_referent_phone: '',
    start_date: '',
    end_date: '',
    notes: '',
    quotation: '',
    quotation_date: '',
    purchase_price: null,
    selling_price: null,
    invoice: '',
    status: '',
    rides: []
};
